/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-statements */
import { brand } from '../../../theme/themePrimitives';
import { ClientToggleType } from '../../../params/redux';
import CustomDropdown from '../dropdown';
import NavbarSelection from './item_selector';
import { replaceToggleState } from '../../../redux/slices/index';
import { settingSelectedClient } from '../../../redux/slices/client';
import { settingSelectedPipeline } from '../../../redux/slices/pipeline';
import { settingSelectedTab } from '../../../redux/slices/task';
import { styled } from '@mui/material/styles';
import { AppDispatch, RootState } from '../../../redux/store';
import { AttachMoneyOutlined, Close, ContactEmergencyOutlined, DescriptionOutlined, EditOutlined, EventNoteOutlined, HandshakeOutlined, MenuOpenOutlined, PeopleAltOutlined, PersonSearchOutlined, SettingsOutlined, Speed, WidgetsOutlined } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, SelectChangeEvent, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { resetStatesExceptAuth, resetStatesExceptAuthAndClient } from '../../../helper/reset_helper';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

const StyledToggleButton = styled(ToggleButton)(({ selected }) => ({
    border: 'none !important',
    backgroundColor: selected ? `${brand[300]} !important` : 'transparent',
    color: selected ? 'white !important' : 'black',
    fontSize: '0.9rem !important',
    fontWeight: '600 !important',
    padding: '8px 10px !important',
    borderRadius: '10px !important',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
    // boxShadow: selected ? '1px 1px 1px 1px #ededed' : 'none'
}));

const StyledToggleGroupBox = styled(ToggleButtonGroup)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
}));

const NavbarComponent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { clients, selectedClient } = useSelector((state: RootState) => state.client);
    const { currentUser, selectedToggles } = useSelector((state: RootState) => state.app);
    const [navigateValue] = useState('dashboard');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openPopup, setOpenPopup] = useState<null | HTMLElement>(null);
    // const [selectedItems, setSelectedItems] = useState<string[]>([
    //     'dashboard',
    //     'task-files',
    //     'billing',
    //     'sales-marketing',
    //     'lead-management',
    //     'team-space',
    //     'customer-management',
    //     'review-management',
    //     'calendar',
    //     'integration'
    // ]);
    const isLaptop = useMediaQuery('(max-width:2000px)');
    const isSmallLaptop = useMediaQuery('(max-width:1400px)');
    const isTablet = useMediaQuery('(max-width:1100px)');
    const isSmallTablet = useMediaQuery('(max-width:900px)');
    const isIphone = useMediaQuery('(max-width:750px)');
    const isPhone = useMediaQuery('(max-width:700px)');

    const handleMenuClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const menuItemForCustomer = [
        { value: 'dashboard', label: 'Dashboard', icon: <Speed /> },
        { value: 'task-files', label: 'Task & Files', icon: <WidgetsOutlined /> },
        { value: 'sales-marketing', label: 'Deals', icon: <AttachMoneyOutlined /> },
        { value: 'lead-management', label: 'Lead Management', icon: <PersonSearchOutlined /> },
        { value: 'team-space', label: 'Message Board', icon: <PeopleAltOutlined /> },
        { value: 'calendar', label: 'Calendar', icon: <EventNoteOutlined /> }
    ];

    const menuItems = [
        { value: 'dashboard', label: 'Dashboard', icon: <Speed /> },
        { value: 'task-files', label: 'Task & Files', icon: <WidgetsOutlined /> },
        { value: 'billing', label: 'Billing', icon: <DescriptionOutlined /> },
        { value: 'sales-marketing', label: 'Sales & Marketing', icon: <AttachMoneyOutlined /> },
        { value: 'lead-management', label: 'Lead Management', icon: <PersonSearchOutlined /> },
        { value: 'team-space', label: 'Team Space', icon: <PeopleAltOutlined /> },
        { value: 'customer-management', label: 'Client Team', icon: <HandshakeOutlined /> },
        { value: 'review-management', label: 'Review Management', icon: <ContactEmergencyOutlined /> },
        { value: 'calendar', label: 'Calendar', icon: <EventNoteOutlined /> },
        { value: 'integration', label: 'Integration', icon: <SettingsOutlined /> }
    ];

    const allItems = currentUser?.role === 'client' ? menuItemForCustomer : menuItems;
    const filteredAllItems = allItems.filter((item) => {
        if (selectedClient?.company_type === 'project' && item.value === 'billing') return false;
        return selectedToggles?.includes(item.value as ClientToggleType);
    });

    let splitIndex = filteredAllItems.length;
    if (isLaptop && !isSmallLaptop && currentUser?.role !== 'client') {
        splitIndex = filteredAllItems.length - 3;
    } else if (isSmallLaptop && !isTablet && currentUser?.role !== 'client') {
        splitIndex = filteredAllItems.length - 4;
    } else if (isTablet && !isSmallTablet && currentUser?.role !== 'client') {
        splitIndex = filteredAllItems.length - 5;
    } else if (isSmallTablet && !isIphone && currentUser?.role !== 'client') {
        splitIndex = filteredAllItems.length - 6;
    } else if (isIphone && !isPhone && currentUser?.role !== 'client') {
        splitIndex = filteredAllItems.length - 7;
    } else if (isIphone && currentUser?.role !== 'client') {
        splitIndex = 0;
    } else {
        splitIndex = filteredAllItems.length;
    }
    const visibleItems = filteredAllItems.slice(0, splitIndex);
    const moreItems = filteredAllItems.slice(splitIndex);


    const dropdownOptions = clients.map((item) => ({
        label: item.company_name,
        value: item.id
    }));

    const onCloseHandler = () => {
        resetStatesExceptAuth(dispatch);
        dispatch(settingSelectedClient(null));
        navigate('/app/dashboard');
    };

    const navigateHandler = (e: React.MouseEvent<HTMLElement>, value: string) => {
        if (value === 'more') {
            return;
        }
        if (!location.pathname.includes(value)) {
            if (value === 'task-files') {
                dispatch(settingSelectedTab(0));
            }
            navigate(`/app/client/${id}/${value || 'dashboard'}`);
        }
        dispatch(settingSelectedPipeline(null));
        handleMenuClose();
    };

    const CompanyChangeHandler = async (event: SelectChangeEvent<unknown>) => {
        try {
            // Wait for the reset action to complete
            await resetStatesExceptAuthAndClient(dispatch);
            const selected_client = clients.findIndex((item) => item.id === event.target.value);
            dispatch(settingSelectedClient(clients[selected_client]));
            // Navigate to the new page
            navigate(`/app/client/${event.target.value}/dashboard`);
        } catch (error) {
            console.error('Error handling company change:', error);
        }
    };

    return (
        <Box bgcolor="white" display="flex" justifyContent="space-between" alignItems="center" p={2}>
            <Box maxWidth="200px">
                {currentUser?.role === 'client'
                    ? <Typography variant="subtitle1">{selectedClient?.company_name}</Typography>
                    : <CustomDropdown
                        options={dropdownOptions}
                        value={id || ''}
                        onChange={CompanyChangeHandler}
                        sx={{
                            mb: 0
                        }}
                    />}
            </Box>
            <Box>
                <Box>
                    <StyledToggleGroupBox
                        color="primary"
                        value={navigateValue}
                        exclusive
                        onChange={navigateHandler}
                        aria-label="Platform navigation"
                    >
                        {
                            visibleItems.map((item) => (
                                <StyledToggleButton key={item.value} value={item.value} selected={location.pathname.includes(item.value)}>
                                    {item.icon} {item.label}
                                </StyledToggleButton>
                            ))
                        }
                        {moreItems.length > 0 && (
                            <StyledToggleButton value="more" selected={false} onClick={handleMenuClick}>
                                <MenuOpenOutlined /> More
                            </StyledToggleButton>
                        )}
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                            {moreItems.map((item) => (
                                <MenuItem key={item.value} onClick={(e) => navigateHandler(e, item.value)} selected={location.pathname.includes(item.value)}>
                                    <Box display="flex" gap={2} alignItems="center">{item.icon}<Typography>{item.label}</Typography></Box>
                                </MenuItem>))}
                        </Menu>
                    </StyledToggleGroupBox>
                </Box>
            </Box>
            <Box>
                {currentUser?.role !== 'client' && (
                    <Box>
                        <IconButton onClick={(event) => setOpenPopup(openPopup ? null : event.currentTarget)}>
                            <EditOutlined />
                        </IconButton>
                        <IconButton onClick={onCloseHandler}>
                            <Close />
                        </IconButton>
                    </Box>
                )}
            </Box>
            <NavbarSelection
                openPopup={openPopup}
                closePopup={() => setOpenPopup(null)}
                menuItems={menuItems}
                selectedItems={selectedToggles}
                submitHandler={(value: string[]) => dispatch(replaceToggleState(value))}
            />
        </Box>
    );
};
export default NavbarComponent;